import React from "react";
import Connecter from "../components/Connexion";
import ScrollToTop from "../components/ScrollToTop";

const SeConnecter = () => {
  return (
    <>
      <ScrollToTop />
      <Connecter />
    </>
  );
};

export default SeConnecter;
